import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductService } from '../../services/productservice';
import { environment } from '@env/environment';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit {
  islandsData: any[] = [];
  categoryData: any[] = [];
  islandIndex: number = 0;
  dynamicFontSize: number = 6; // Default size in vmin
  dynamicDescriptionFontSize: number = 1.5; // Default size in vmin
  isDescriptionExpanded = false; // For see more/less functionality

  constructor(private router: Router, private http: HttpClient, private productService: ProductService) {}

  ngOnInit(): void {
    this.getIslandsData();
    this.calculateFontSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.calculateFontSize();
  }

  calculateFontSize(): void {
    const width = window.innerWidth;
    const height = window.innerHeight;

    this.dynamicFontSize = Math.min(width, height) * 0.06; // 8% of the smaller dimension
    this.dynamicDescriptionFontSize = Math.min(width, height) * 0.015; // 1.5% of the smaller dimension

    this.dynamicFontSize = Math.max(40, Math.min(this.dynamicFontSize, 100));
    this.dynamicDescriptionFontSize = Math.max(8, Math.min(this.dynamicDescriptionFontSize, 20));

    this.dynamicFontSize = (this.dynamicFontSize / Math.min(width, height)) * 100;
    this.dynamicDescriptionFontSize = (this.dynamicDescriptionFontSize / Math.min(width, height)) * 100;
  }

  private buildBannerImageUrl(path: string): string {
    if (!path) {
      return '';
    }
    // Already an absolute URL — use as-is
    if (/^https?:\/\//i.test(path)) {
      return path;
    }
    // Relative path — prepend admin base URL
    return environment.adminBaseURL.toLowerCase() + (path.startsWith('/') ? path : '/' + path);
  }

  getIslandsData(): void {
    this.productService.get360Info().then((result: any) => {
      result.forEach((element: any) => {
        const islandData = {
          name: element.title,
          description: element.body,
          id: element.field_listing_id,
          image: this.buildBannerImageUrl(element.field_banner_image),
          route: 'listingdetails',
          routeParam: element.field_listing_id,
          url: 'listingdetails/' + element.field_listing_id,
          full_screen_url: element.field_full_screen_url,
        };
        this.islandsData.push(islandData);
      });
    });
  }

  updateIsland(): void {
    // Keep readmore state open when navigating between islands
    // this.isDescriptionExpanded = false;
  }

  toggleDescription(): void {
    this.isDescriptionExpanded = !this.isDescriptionExpanded;
  }

  exploreNow(): void {
    const activeIslandId = this.islandsData[this.islandIndex].id;
    this.router.navigate(['/listingdetails', activeIslandId]);
  }

  fullScreen(): void {
    const activeIslandUrl = this.islandsData[this.islandIndex].full_screen_url;
    window.open(activeIslandUrl, '_blank');
  }

  goToPrevIsland(): void {
    if (this.islandIndex <= 0) {
      this.islandIndex = this.islandsData.length - 1;
    } else {
      this.islandIndex--;
    }
    this.updateIsland();
  }

  goToNextIsland(): void {
    if (this.islandIndex >= this.islandsData.length - 1) {
      this.islandIndex = 0;
    } else {
      this.islandIndex++;
    }
    this.updateIsland();
  }

  navigateToIsland(index: number): void {
    this.islandIndex = index;
    this.updateIsland();
  }

  onCategorySelection(categoryIndex: number): void {
    if (this.islandsData[categoryIndex]) {
      this.islandIndex = categoryIndex;
      this.updateIsland();
    }
  }
}
